import React, { Component } from 'react';
import '../styles/Banner.css';

import {
    NavLink
  } from "react-router-dom";

import PropTypes from 'prop-types'


class Banner extends Component {
    static contextTypes = {
        router: PropTypes.object
    }
    redirectToModel = () => {
        this.context.router.history.push(`/modelo`)
    }
    render(){
        let button;
        if(this.props.textButton) {
            button = <button class={`btn-conocenos ${this.props.className}`} onClick={this.redirectToModel}>{this.props.textButton}</button>
        }else{
            button = "";
        }
        return (
            <div className={`Banner ${this.props.className}`}>
                <div className={`banner-container ${this.props.className}`}>
                    <img src={this.props.imageBanner} alt="Nature"/>
                </div>
                <div class={`banner-text ${this.props.className}`}>
                    <h4 className={`${this.props.className}`}>{this.props.title}</h4>
                    <p className={`${this.props.className}`}>{this.props.description}</p>
                    {button}
                    {this.props.customComponent}
                </div>
            </div>
        );
    }
}


export default Banner;


// WEBPACK FOOTER //
// ./src/components/Banner.js